module.exports = __webpack_public_path__ + "img/E-WEB-Goal-11.00060950.png";